export const font = {
    width: 8,
    height: 5,
    number: [
        ['  ,--.  ', ' /    \\ ', '|  ()  |', ' \\    / ', '  `--\'  '],
        ['   ,--. ', '  /   | ', '  `|  | ', '   |  | ', '   `--\' '],
        ['  ,---. ', ' \'.-.  \\', '  .-\' .\'', ' /   \'-.', ' \'-----\''],
        [' ,----. ', ' \'.-.  |', '   .\' < ', ' /\'-\'  |', ' `----\' '],
        ['   ,---.', '  /    |', ' /  \'  |', ' \'--|  |', '    `--\''],
        [' ,-----.', ' |  .--\'', ' \'--. `\\', ' .--\'  /', ' `----\' '],
        ['   ,--. ', '  /  .\' ', ' |  .-. ', ' \\   o |', '  `---\' '],
        [' ,-----.', ' \'--,  /', '  .\'  / ', ' /   /  ', ' `--\'   '],
        ['  ,---. ', ' |  o  |', ' .\'   \'.', ' |  o  |', '  `---\' '],
        ['  ,---. ', ' | o   \\', ' `..\'  |', '  .\'  / ', '  `--\'  ']
    ],
};
